import React from 'react';

const JournalSection = ({ currentTheme, theme, journalMatchesSearch, journalEntry, setJournalEntry, journalRef, handleSaveJournal, savingJournal }) => {
  return (
    <div className="mt-6 mb-4">
      <div className={`${currentTheme.colors.journal} border-2 rounded-lg shadow-lg hover:shadow-xl transition-all p-4 ${
        journalMatchesSearch
          ? 'border-blue-500 dark:border-blue-400 ring-2 ring-blue-200 dark:ring-blue-600'
          : ''
      }`}>
        <div className="flex items-center justify-between mb-3">
          <h3 className={`text-lg font-bold ${currentTheme.colors.journalText} ${currentTheme.headingFont || ''}`}>
            {theme === 'executive' ? "TODAY'S JOURNAL / NOTES" : "Today's Journal / Notes"}
          </h3>
          {journalMatchesSearch && (
            <span className="text-xs bg-blue-100 dark:bg-blue-200 text-blue-700 dark:text-blue-900 px-2 py-1 rounded-full font-medium">
              Match found
            </span>
          )}
        </div>
        <div className="relative">
          <textarea
            ref={journalRef}
            value={journalEntry}
            onChange={(e) => setJournalEntry(e.target.value)}
            onBlur={handleSaveJournal}
            placeholder=""
            rows={3}
            className={`w-full resize-none border-0 bg-transparent ${currentTheme.colors.journalText} placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none relative z-10 journal-textarea-lined`}
            style={{ minHeight: '72px', maxHeight: '400px', overflow: 'auto', lineHeight: '24px', paddingTop: '0px', backgroundAttachment: 'local' }}
            data-testid="journal-textarea"
          />
        </div>
        {savingJournal && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">Saving...</p>
        )}
      </div>
    </div>
  );
};

export default JournalSection;
